/**
 * AI 生文- 修改会话名称
 * @returns
 */
 import {
  Flex,
  Button,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormErrorMessage,
  Textarea,
} from "@chakra-ui/react";
import { useState } from "react";
import { Field, Form, Formik, FormikErrors } from "formik";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser } from "@/reducer/userslice";
import { addChat } from "@/services/api/thunks/chat";

type editInfoType = { 
  sessionName: string;
  sessionId:string;
  userId:string; 
  roleSetting: string;
}

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const CreateChatModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  
  const newChatForm ={
    sessionName: "",
    roleSetting: ""
  }

  const handleValidate1 = (values: { sessionName: string , roleSetting: string}) => {
    const errors: FormikErrors<{ sessionName: string }> = {};
    if (!values.sessionName) {
      errors.sessionName = "会话名称不能为空";
    }
    // if (!values.roleSetting) {
    //   errors.sessionName = "角色设定不能为空";
    // }
    return errors;
  };

  const handleSubmit = async (values: { sessionName: string,  roleSetting: string }) => {
    const action = await dispatch(addChat({ user_id: user.id, title: values.sessionName, role: values.roleSetting }));
    // console.log(action, "action>>>>>>")
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent w="420px" bg="#fff">
      <ModalHeader color="#27314D" fontSize={"18px"}>
        新建聊天
      </ModalHeader>
      <ModalCloseButton color={"#B9B9B9"} />
      <ModalBody pb={6}>
        <Formik
          initialValues={newChatForm}
          onSubmit={handleSubmit}
          validate={handleValidate1}
        >
          <Form>
            <Field name="sessionName">
              {({ field, form }: any) => (
                <FormControl
                  // mt={"20px"}
                  isInvalid={
                    form.errors.sessionName && form.touched.sessionName
                  }
                >
                  <Input
                    {...field}
                    h="46px"
                    // bg="rgba(0, 0, 0, 0.3)"
                    color="#27314D"
                    fontSize={"14px"}
                    // border="none"
                    placeholder="会话名称"
                    // borderRadius={0}
                  />
                  <FormErrorMessage>
                    {form.errors.sessionName}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Field name="roleSetting">
              {({ field, form }: any) => (
                <FormControl
                  mt={"20px"}
                  isInvalid={
                    form.errors.roleSetting && form.touched.sroleSetting
                  }
                >
                  <Textarea
                    {...field}
                    h="46px"
                    // bg="rgba(0, 0, 0, 0.3)"
                    color="#27314D"
                    fontSize={"14px"}
                    // border="none"
                    placeholder="角色设定"
                    // borderRadius={0}
                  />
                  <FormErrorMessage>
                    {form.errors.roleSetting}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>

            <Flex mt="40px" justifyContent={"flex-end"}>
              <Button
                w="76px"
                h="37px"
                mr="15px"
                bg="#CBD1DF"
                color={"#27314D"}
                fontSize="12px"
                fontWeight={"normal"}
                borderRadius={0}
                _hover={{
                  bg: "#CBD1DF",
                  color: "#8E94A9",
                }}
                onClick={handleClose}
              >
                取消
              </Button>
              <Button
                w="76px"
                h="37px"
                bg="#496AE1"
                color={"#FFFFFF"}
                fontSize="12px"
                fontWeight={"normal"}
                borderRadius={0}
                _hover={{
                  bg: "#3F5BC1",
                  color: "#E6E6E6",
                }}
                type="submit"
              >
                保存
              </Button>
            </Flex>
          </Form>
        </Formik>
      </ModalBody>
    </ModalContent>
  </Modal>
  );
};

export default CreateChatModal;
